import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Skeleton: the loading placeholder. In a module of its own, with no imports,
 * so a route's eager part can show it without pulling in the rest of the
 * component library (the /design route's pending state does).
 */
export function Skeleton({ lines = 3, label = 'Loading', variant = 'text', }) {
    return (_jsx("div", { className: "cx-skeleton", role: "status", "aria-label": label, "data-variant": variant, children: Array.from({ length: lines }, (_, i) => (_jsx("span", { className: "cx-skeleton__bar", "aria-hidden": "true" }, i))) }));
}
//# sourceMappingURL=skeleton.js.map